export default [
  {
    path: '/admin/user/faculty-staff/staff-index',
    name: 'M020028',
    component: () => import('@/views/admin/user/faculty-staff/StaffIndex.vue'),
    meta: { layout: 'admin' },
  },

  {
    path: '/admin/user/student/student-index',
    name: 'M020029',
    component: () => import('@/views/admin/user/student/StudentIndex.vue'),
    meta: { layout: 'admin' },
  },
];
